import React, { useState, useEffect,useContext } from 'react';
import DynamicIcon from '../dynamicicon';
import JisButton from './jisButton';
import * as Constants from '../../constants';
import { ShareContext } from '../../context/ShareContext';
import JisCheckbox from './jisCheckbox';

function JisParty({ title="" , onSave,defaultParty}) {
    const {  activePage, token, profile, setIsExpired,frequentData} = useContext(ShareContext);
  const [party, setParty] = useState(defaultParty);
     const [locs2, setLocs2]=useState({state:null,lga:null,city:null})
     const [states, setStates] =useState([]);
 const [Lga2, setLga2] = useState([]);
     const [cities2, setCities2] = useState([]);
     const [showLead, setShowLead] = useState(false);
 
     const idModes=[
        {label:'Passport',value:'Passport'},
        {label:'National ID', value:'National ID'},
        {label:'Driving Licence', value:'Driving Licence'},
        {label:'Others', value:'Others'}
    ]
 const partydes=[
        {label:'Individual', value:0},
        {label:'Organization',value:1},

    ]
 
    useEffect(() => {
  console.log(frequentData);
        onGetStates();
  
        }, [])
  useEffect(() => {
 
    setParty(defaultParty);
  
        }, [defaultParty])
        
     const onGetStates= async()=>{
        //for account registration
        try {
    
        
            const resp = await fetch(`${Constants.apiUrl}/profile/states`, { 
              method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': '',}, });  
            const data = await resp.json();
           
           setStates(data); 
          } catch (error) {
            
            console.error(error);   
          }
    }
useEffect(() => {
    if(party.state){
        onGetLgs2(party.state);
    }  
}, [party.state])
useEffect(() => {
    if(party.lga){
    onGetCities2(party.lga);
    }     
}, [party.lga])

    const onSaveParty=(e)=>{
         e.preventDefault();

       var _party={...party, isOrg:party.isOrg=='1'?true:false}
       onSave(party);
        setParty({isOrg:0, isLeadParty:false, state:Constants.Default_State,suffix:'',
           firstName:'', middleName:'',lastName:'',primaryContactNumber:'',
           secondaryContactNumber:'',primaryEmail:'',secondaryEmail:'',
           address1:'',address2:'',lga:'',cityId:'',identificationMode:'',IdentificationDesc:'', partyTypeId:''
        });
    
    }

 const onPartyChange = (e) => {
    
    if([e.target.name]=='partyTypeId'){
        const v=e.target.value;
        const isl=Constants.getItemById(frequentData.partyTypes,v)?.isLead??false;
        setParty({...party, [e.target.name]:v, isLeadParty:isl })
        setShowLead(isl);
    }else{
      setParty({...party, [e.target.name]: e.target.value})  
    }
 
}
const onGetLgs2= async(stateid)=>{
    //for account registration
    try {
        //setLocs({...locs,lga:false});
        const resp = await fetch(`${Constants.apiUrl}/profile/lgs/${stateid}`, { 
          method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': '',}, });  
        const data = await resp.json();
       setLga2(data);
       // setLocs2({...locs2,lga:true});
       
      } catch (error) {
       // setLocs2({...locs2,lga:null});
        console.error(error);   
      }
}
const onGetCities2= async(lgid)=>{
    //for account registration
    try {
       //setLocs({...locs,city:false});
       
        const resp = await fetch(`${Constants.apiUrl}/profile/cities/${lgid}`, { 
          method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': '',}, });  
        const data = await resp.json();
       setCities2(data);
       setLocs2({...locs2,city:true});
       
      } catch (error) {
        setLocs2({...locs2,city:null});
        console.error(error);   
      }
}

  return  <form   onSubmit={onSaveParty}>   
            <div style={{display:'flex'}}>
            <div className="select-group">
                            <label> Party Type <span className="required">*</span> </label>
                            <select name="partyTypeId" value={party.partyTypeId} required={true} onChange={onPartyChange} >
                                <option value="">Select </option>
                                {frequentData.partyTypes?.map((opt) => (
                                <option key={opt.id} value={opt.id}>
                                    {opt.title}
                                </option>
                                ))}
                            </select>          
                    </div>
                    <div className="select-group">
                            <label> Party Description <span className="required">*</span> </label>
                            <select   required={true} name="isOrg"  value={party.isOrg} onChange={onPartyChange} >
                                
                                {partydes?.map((opt,index) => (
                                <option key={index} value={opt.value}>
                                    {opt.label}
                                </option>
                                ))}
                            </select>          
                    </div>
                    

                    
        </div>
                     
 {party.isOrg==0 &&  <div style={{display:'flex'}}>
    <div className="select-group">
            <label> Title <span className="required">*</span> </label>
            <select name="suffix" value={party.suffix} required={true} onChange={onPartyChange} >
                    <option value="">Select Title</option>
                <option  value="Mr">Mr</option>
                <option value="Mrs">Mrs</option>
                <option value="Miss">Miss</option>
                <option value="Barrister">Barrister</option>
                <option value="Dr">Dr</option>
                <option value="Dr(Mrs)">Dr(Mrs)</option>
                <option value="Chief">Chief</option>
                <option value="Chief(Mrs)">Chief(Mrs)</option>
                <option value="Engr">Engr</option>
                <option value="Engr(Mrs)">Engr(Mrs)</option>
                <option value="Alhaji">Alhaji</option>
                <option value="Alhaja">Alhaja</option>
                <option value="Rev">Rev</option>
                <option value="Pastor">Pastor</option>
                <option value="Admiral">Admiral</option>
                <option value="General">General</option>
                <option value="Air Comm.">Air Comm.</option>
                <option value="Captain">Captain</option>
                <option value="Lt. Col">Lt. Col</option>
                <option value="Rev(Mrs)">Rev(Mrs)</option>
                <option value="Bishop">Bishop</option>
                <option value="Arch Bishop">Arch Bishop</option>
                <option value="Primate">Primate</option>
                <option value="Architect">Architect</option>
                
            </select>
                        </div>
<div  className="input-group">
                        <label>First Name  <span className="required">*</span> </label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="group" />
                            <input placeholder='First Name' autoComplete="off" required={true} name="firstName" type='text' value={party.firstName} onChange={onPartyChange}   />
                        </div>
                    </div>
                   

                    <div  className="input-group">
                        <label>Middle Name  </label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="group" />
                            <input placeholder='Middle Name' autoComplete="off"  name="middleName" type='text' value={party.middleName} onChange={onPartyChange}   />
                        </div>
                    </div>
                    
</div>}
                         
{party.isOrg==0 &&  <div  className="input-group">
                        <label>Last Name  <span className="required">*</span> </label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="group" />
                            <input placeholder='lastName' autoComplete="off" required={true} name="lastName" type='text' value={party.lastName??''} onChange={onPartyChange}   />
                        </div>
                    </div>} 
  {party.isOrg==1 &&  <div  className="input-group">
                        <label>Organization Name <span className="required">*</span> </label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="group" />
                            <input placeholder='Organization Name' autoComplete="off" required={true} name="firstName" type='text' value={party.firstName} onChange={onPartyChange}   />
                        </div>
                    </div> }                 

<div style={{display:'flex'}}>
<div  className="input-group">
                        <label>Primary Phone {party.isLeadParty && <span className="required">*</span>} </label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="group" />
                            <input placeholder='Primary Phone' autoComplete="off" required={party.isLeadParty} name="primaryContactNumber" type='tel' value={party.primaryContactNumber} onChange={onPartyChange}   />
                        </div>
                    </div>
                    <div  className="input-group">
                        <label>Alternate Phone  </label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="group" />
                            <input placeholder='Alternate Phone' autoComplete="off"  name="secondaryContactNumber" type='tel' value={party.secondaryContactNumber} onChange={onPartyChange}   />
                        </div>
                    </div>
</div>

<div style={{display:'flex'}}>
<div  className="input-group">
                        <label>Primary Email  {party.isLeadParty && <span className="required">*</span>} </label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="group" />
                            <input placeholder='Primary Email' autoComplete="off" required={party.isLeadParty} name="primaryEmail" type='email' value={party.primaryEmail} onChange={onPartyChange}   />
                        </div>
                    </div>

                      <div  className="input-group">
                        <label>Alternate Email   </label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="group" />
                            <input placeholder='Alternate Email' autoComplete="off" required={false} name="secondaryEmail" type='email' value={party.secondaryEmail} onChange={onPartyChange}   />
                        </div>
                    </div>
</div>
                   
<div  style={{display:'flex'}}>
    <div  className="input-group">
                        <label>Address 1 {party.isLeadParty && <span className="required">*</span>} </label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="group" />
                            <input placeholder='Address 1' required={true}  name="address1" type='text' value={party.address1} onChange={onPartyChange}   />
                        </div>
                    </div>
                    <div  className="input-group">
                        <label>Address 2 </label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="group" />
                            <input placeholder='Address 2' required={false} autoComplete="off" name="address2" type='text' value={party.Address2} onChange={onPartyChange}   />
                        </div>
                    </div>
</div>                 

  <div style={{display:'flex'}}>
                         <div className="select-group">
                            <label> State <span className="required">*</span></label>
                            <select name="state" required={true} value={party.state} onChange={onPartyChange} >
                               {locs2.state==null  && <option value="">Select state</option>}
                                {locs2.state==false && <option value="">loading state</option>}
                                {locs2.state  && <option value="">Select state</option>}

                                {states?.map((opt) => (
                                <option key={opt.id} value={opt.id}>
                                    {opt.title}
                                </option>
                                ))}
                            </select>
                            </div>
                        <div className="select-group">
                            <label> L.G.A <span className="required">*</span></label>
                            <select  name="lga" value={party.lga} required={true} onChange={onPartyChange}>
                                {locs2.lga==null  && <option value="">Select State first</option>}
                                {locs2.lga==false && <option value="">loading LG</option>}
                                {locs2.lga  && <option value="">Select LG</option>}


                                {Lga2?.map((opt) => (
                                <option key={opt.id} value={opt.id}>
                                    {opt.title}
                                </option>
                                ))}
                            </select>
                            </div>
                       <div className="select-group">
                            <label> City <span className="required">*</span></label>
                            <select  name="cityId" value={party.cityId} required={true} onChange={onPartyChange}>
                                {locs2.city==null  && <option value="">Select LGA first</option>}
                                {locs2.city==false && <option value="">loading cities</option>}
                                {locs2.city && <option value="">Select city</option>}
                                {cities2?.map((opt) => (
                                <option key={opt.id} value={opt.id}>
                                    {opt.title}
                                </option>
                                ))}
                            </select>
                            </div>
                    </div> 
                    
                   
                    <div  style={{display:'flex',justifyContent:'center'}}>
                        <div className="select-group">
                        <label> Identification Mode  </label>
                                <select name="identificationMode" value={party.identificationMode}  onChange={onPartyChange} >
                                    <option value="">Select </option>
                                    {idModes?.map((opt) => (
                                    <option key={opt.value} value={opt.value}>
                                        {opt.label}
                                    </option>
                                    ))}
                                </select>
                        </div>

                        <div  className="input-group">
                            <label>Identification Number </label>
                            <div className='input-wrapper'>
                                <DynamicIcon iname="group" />
                                <input placeholder='Identification Number' name="IdentificationDesc" maxLength={20} value={party.identificationDesc} onChange={onPartyChange}   />
                            </div>
                        </div>

                       {party.isOrg==0 &&
                       
                        <div className="select-group">
                        <label> Gender  </label>
                                <select name="sex" value={party.sex}  onChange={onPartyChange} >
                                    <option value="">Select </option>
                                    {Constants.gender?.map((opt) => (
                                    <option key={opt.value} value={opt.value}>
                                        {opt.label}
                                    </option>
                                    ))}
                                </select>
                        </div>

                       
                    
                     }  
                    </div>
              {showLead && <JisCheckbox value={party.isLeadParty}  label={"Lead party?"} onChange={(e)=> setParty({...party, isLeadParty:e})} />}    
            <div>
                <JisButton type='submit' icon="save" >Save Party</JisButton>
            </div></form>;
}

export default JisParty;